module.exports = __webpack_public_path__ + "img/infographicWhatWeDoHorisontal.4356c472.png";